<template>
  <v-card
    class="pa-0 rounded-0 elevation-0 mt-5"
    :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-2'"
  >
    <v-sheet
      class="transactionTable ib-commission-table"
      :class="$vuetify.theme.dark ? 'blue-lighten-1' : 'white-lighten-1'"
    >
      <v-data-table
        :headers="headers"
        hide-default-footer
        :items="Transaction"
      >
        <template v-slot:item.DailyView="{ item }">
          <span :class="getDailyClass(item.DailyView)">
            {{ item.DailyView }}
          </span>
        </template>
      </v-data-table>
    </v-sheet>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      headers: [
        { text: "Symbol", align: "start", value: "symbolView" },
        { text: "Bid", value: "BidView" },
        { text: "Ask", value: "AskView" },
        { text: "Daily Cng", value: "DailyView" },
        
      ],
      Transaction: [
        {
          symbolView: "EUR/USD",
          BidView: "149.50",
          AskView: "149.50",
          DailyView: "-2,24%",
          
        },
        {
          symbolView: "EUR/USD",
          BidView: "149.50",
          AskView: "149.50",
          DailyView: "2,24%",
          
        },
        {
          symbolView: "EUR/USD",
          BidView: "149.50",
          AskView: "149.50",
          DailyView: "-2,24%",
          
        },
        {
          symbolView: "EUR/USD",
          BidView: "149.50",
          AskView: "149.50",
          DailyView: "2,24%",
          
        },
        {
          symbolView: "EUR/USD",
          BidView: "149.50",
          AskView: "149.50",
          DailyView: "-2,24%",
          
        },
        {
          symbolView: "EUR/USD",
          BidView: "149.50",
          AskView: "149.50",
          DailyView: "2,24%",
          
        },
        {
          symbolView: "EUR/USD",
          BidView: "149.50",
          AskView: "149.50",
          DailyView: "-2,24%",
          
        },
        
        
      ],
    };
  },
  methods: {
    getDailyClass(value) {
      // Remove % and commas, then parse as float
      const num = parseFloat(value.replace('%', '').replace(',', '.'));
      return num >= 0 ? 'text--green' : 'text--red';
    }
  }
};
</script>
<style scoped>
.text--green {
  color: #4caf50;
}
.text--red {
  color: #f44336;
}
</style>
</script>
